import { render } from "./House.vue?vue&type=template&id=22f90406"
const script = {}
script.render = render

export default script